import templateUrl from "emun.salesrep/territory-manager/division/division-prompt.htm";
import DivisionPromptController from "emun.salesrep/territory-manager/division/division-prompt.controller";
import modals from "webmodals/modals";

const resolve = () => null;
const reject = reason => console.warn('reject reason', reason);

const DivisionPrompt = {
  open(options) {
    const prom = modals.open(Object.assign({
      size: 'lg quick-report-prompt',
      templateUrl,
      resolve: {
        options: () => options
      },
      bindToController: true,
		controller: DivisionPromptController,
      controllerAs: '$ctrl'
    }, (options || {}).modal)).result;

    prom.then(resolve, reject);

    return prom;
  }
};

export default DivisionPrompt;
